import { createHelpers } from 'vuex-map-fields';
import { get_cotizacion_vacia } from 'views/components/crm/components/cotizacion/cotizacion_helper.js';
import { get_solicitud_vacia } from 'views/components/crm/components/solicitud/solicitud_helper.js';
import { get_contrato_vacio } from 'views/components/crm/components/contrato/contrato_helper.js';
import Vuex from 'vuex';

Vue.use(Vuex);

const { getFieldsDetalleSolicitud, updateFieldsDetalleSolicitud } = createHelpers({
  getterType: 'getFieldsDetalleSolicitud',
  mutationType: 'updateFieldsDetalleSolicitud',
});

export default {
  namespaced: true,
  state: {
    contrato: get_contrato_vacio(),
    cotizacion: get_cotizacion_vacia(),
    solicitud: get_solicitud_vacia(),
    historial: {
      contrato: [],
      solicitud: [],
      cotizacion: [],
    },
    llamadas: [],
  },
  mutations: {
    updateFieldsDetalleSolicitud,
  },
  getters: {
    getFieldsDetalleSolicitud,
  },
};
